import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6 mockup" }

import HeroImage from '@/components/home/hero-image.vue'
import HeroLayer from '@/components/home/hero-layer.vue'
import HeroContent from '@/components/home/hero-content.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'hero',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(HeroContent),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(HeroImage)
        ])
      ])
    ])
  ]))
}
}

})